import React from 'react';

import { Banner } from '../Banners/Banner';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';

interface IProps {
  bodyCopy: string | React.JSX.Element;
  buttonCopy?: string;
  alertShade?: string;
  customColor?: string;
  linkType?: 'internal' | 'external';
  linkTo?: string;
  dismissable?: boolean;
  onInteraction?: () => void;
}

/*
 Please note this component shall currently only be used at the top level in order to avoid
 strange styling since it uses a <Banner>.
*/

export const Alert = ({
  bodyCopy = '',
  buttonCopy,
  alertShade,
  customColor,
  linkTo,
  linkType,
  dismissable = true,
  onInteraction,
}: IProps) => {
  return (
    <Banner
      data-testid="alert-banner"
      className={`${alertShade ? `bg-${alertShade}-tint` : `${customColor}`} min-h-11 py-3`}
    >
      <div className="flex flex-row justify-center">
        <div className="body-text-sm flex w-full flex-col items-start justify-center sm:flex-row sm:items-center">
          <div className={`flex ${alertShade ? `text-${alertShade}-shade` : `text-sea-foam`} pr-1`}>
            {bodyCopy}{' '}
            {linkType === 'internal' && linkTo && alertShade && (
              <InternalLink className="text-sea-foam contents" to={linkTo}>
                {buttonCopy}
              </InternalLink>
            )}
            {linkType === 'external' && linkTo && (
              <ExternalLink className="contents" href={linkTo}>
                {buttonCopy}
              </ExternalLink>
            )}
          </div>
        </div>
        {dismissable ? (
          <button
            type="button"
            onClick={onInteraction}
            className="text-trench -mt-1 mr-1 mb-auto ml-auto pl-2 text-2xl md:mt-0"
          >
            &times;
          </button>
        ) : (
          <></>
        )}
      </div>
    </Banner>
  );
};
